(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-research"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-science-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-science-track]');
    const prevBtn = carousel.querySelector('[data-science-prev]');
    const nextBtn = carousel.querySelector('[data-science-next]');
    const dots = carousel.querySelectorAll('[data-science-dot]');
    const slideCount = track.children.length;
    const mq = window.matchMedia('(max-width: 899px)');
    let current = 0;

    const isMobile = () => mq.matches;

    const goTo = (index) => {
      if (!isMobile()) return;
      current = Math.max(0, Math.min(index, slideCount - 1));
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === slideCount - 1;
    };

    const reset = () => {
      if (isMobile()) {
        goTo(0);
      } else {
        track.style.transform = '';
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        current = 0;
      }
    };

    prevBtn.addEventListener('click', () => goTo(current - 1));
    nextBtn.addEventListener('click', () => goTo(current + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

    let startX = 0;
    let deltaX = 0;
    let swiping = false;

    track.addEventListener(
      'touchstart',
      (e) => {
        if (!isMobile()) return;
        startX = e.touches[0].clientX;
        deltaX = 0;
        swiping = true;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (e) => {
        if (!swiping) return;
        deltaX = e.touches[0].clientX - startX;
      },
      { passive: true }
    );

    track.addEventListener('touchend', () => {
      if (!swiping) return;
      swiping = false;
      if (Math.abs(deltaX) > 50) {
        goTo(deltaX < 0 ? current + 1 : current - 1);
      }
    });

    carousel.addEventListener('keydown', (e) => {
      if (!isMobile()) return;
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    if (mq.addEventListener) {
      mq.addEventListener('change', reset);
    }

    reset();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-science-scroll-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-daily-countdown]').forEach((clock) => {
    const hoursEl = clock.querySelector('[data-cd-hours]');
    const minutesEl = clock.querySelector('[data-cd-minutes]');
    const secondsEl = clock.querySelector('[data-cd-seconds]');

    const tick = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const remaining = Math.max(0, Math.floor((midnight - now) / 1000));
      hoursEl.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      minutesEl.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      secondsEl.textContent = String(remaining % 60).padStart(2, '0');
    };

    setInterval(tick, 1000);
    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cta-scroll-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-list]').forEach((list) => {
    const items = list.querySelectorAll('[data-faq-item]');
    items.forEach((item) => {
      item.querySelector('[data-faq-toggle]').addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');
        items.forEach((other) => {
          other.classList.remove('is-active');
          other.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });
        if (!isActive) {
          item.classList.add('is-active');
          item.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-grid"] && !Shopify.designMode) return;
  try {
    
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const counters = document.querySelectorAll('[data-count-up]');

  if (counters.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);

        const original = el.textContent.trim();
        const match = original.match(/-?\d+(?:[.,]\d+)?/);
        if (!match || reduceMotion) return;

        const numStr = match[0];
        const target = parseFloat(numStr.replace(',', '.'));
        const decimals = (numStr.split(/[.,]/)[1] || '').length;
        const prefix = original.slice(0, match.index);
        const suffix = original.slice(match.index + numStr.length);
        const useComma = numStr.includes(',');
        const duration = 1500;
        const startTime = performance.now();

        const tick = (now) => {
          const progress = Math.min(1, (now - startTime) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          let value = (target * eased).toFixed(decimals);
          if (useComma) value = value.replace('.', ',');
          el.textContent = prefix + value + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });

    counters.forEach((el) => observer.observe(el));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-testimonials-scroll-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transformation-timeline"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-transformation-timeline]').forEach((timeline) => {
    const fill = timeline.querySelector('[data-timeline-fill]');
    const items = timeline.querySelectorAll('[data-timeline-item]');
    let ticking = false;

    const update = () => {
      const rect = timeline.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const trigger = vh * 0.55;

      const distance = trigger - rect.top;
      const pct = Math.max(0, Math.min(1, distance / rect.height));
      fill.style.height = pct * 100 + '%';

      items.forEach((item) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.top + itemRect.height / 2;
        item.classList.toggle('is-active', itemCenter < trigger);
      });

      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
